import ApiClient from "../helpers/ApiClient";


export const addData = async ({ file,title, subtitle }) => {
    try {
        const response = await ApiClient.post(`/Careers/addCareerFlyer`,
            { file, title, subtitle },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getData = async () => {
    try {
        const response = await ApiClient.get(`/Careers/getCareerFlyer`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const editData = async ({ id, file, title, subtitle }) => {

    try {
        const response = await ApiClient.put(`/Careers/updateCareerFlyer/${id}`,
            { file, title, subtitle  },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response  edit", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/Careers/deleteCareerFlyer/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}